export default __webpack_public_path__ + "static/media/layout.f4e364fb.webp";